import { store } from 'redux/store';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import { transformJSON } from './inspection';

export const transformFormWrapperDataToWorkRequestData = async (
  data,
  id,
  inspection,
  updateApp = false
) => {
  const { pipeline, structure, cache } = store.getState();

  const photoData = inspection
    ? data?.photo
    : await transformPhotoData(data?.photo, 'WorkRequest', updateApp);
  const documentList = inspection
    ? data?.document
    : await transformDocumentData(data?.document, 'WorkRequest', updateApp);

  let newRecordId = inspection
    ? inspection
    : (!inspection && localStorage.getItem('newRecordId')) || uuidv4();

  const uniqueId = !_.isEmpty(id) ? id : newRecordId;

  const { pipelineMobileMap = {}, pipelineMobile = [] } = pipeline;
  const { structureMobile = [], structureMobileMap = {} } = structure;
  const { equipmentsMap = {}, equipments: cacheEquipments = [] } = cache;

  let appliesToType = '';
  let uniqueSiteIdsForPipeline = [];
  let structureSiteId = '';
  let equipmentSiteId = '';
  if (!id || !data?.appliesToType) {
    appliesToType = data?.siteId
      ? 'site'
      : data?.equipmentId
      ? 'equipment'
      : data?.structureId
      ? 'structure'
      : data?.pipelineId
      ? 'pipeline'
      : '';
  } else {
    appliesToType = data?.appliesToType;
  }
  if (appliesToType === 'pipeline') {
    const pipeLineData = id ? {} : pipelineMobile[pipelineMobileMap[data?.pipelineId]] || {};

    const siteIds = pipeLineData
      ? new Set([
          ...(pipeLineData?.fromSite ? [pipeLineData.fromSite] : []),
          ...(pipeLineData?.toSite ? [pipeLineData.toSite] : []),
          ...(pipeLineData?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeLineData?.wells?.map((x) => x.toLowerCase()) ?? [])
        ])
      : [];

    // get unique site ids, if work request created from pipeline
    uniqueSiteIdsForPipeline = data?.sites || Array.from(siteIds);
  } else if (appliesToType === 'structure') {
    const structureData = id ? {} : structureMobile[structureMobileMap[data?.structureId]] || {};
    structureSiteId = data?.siteId || structureData?.siteId;
  } else if (appliesToType === 'equipment') {
    const equipmentData =
      id && data?.appliesToType && data?.siteId
        ? {}
        : cacheEquipments[equipmentsMap[data?.equipmentId]] || {};
    equipmentSiteId = data?.siteId || equipmentData?.siteId;
  }

  return {
    appliesToType,
    newWorkRequest: true,
    title: data?.title || null,
    priorityId: data?.priority || null,
    typeId: data?.type || null,
    trade: data?.trade || null,
    due: data?.requestDueDate || undefined,
    description: data?.description || null,
    detailInspections: data?.detailInspections || [],
    recordNumber: data?.recordNumber || null,
    recordTitle: data?.recordTitle || null,
    ...(data?.responsibleUsers && {
      responsible: [
        {
          woUserRequestId: data?.responsibleUsers || null
        }
      ]
    }),
    ...(data?.administrator && {
      administrators: [
        {
          woUserRequestId: data?.administrator || null
        }
      ]
    }),
    status: data?.status,
    photos: photoData || [],
    documents: documentList || [],
    siteId: data?.siteId || structureSiteId || equipmentSiteId || null,
    woId: uniqueId,
    workorderId: uniqueId,
    result: 'completed',
    entity: 'WorkRequest',
    counterReadings: null,
    type: 'New Work Request',
    labours: null,
    partEstimates: null,
    failureModes: null,
    parts: null,
    outcomeId: null,
    // completed: null,

    originId: null,
    pipelineId: data?.pipelineId || null,
    equipmentId: data?.equipmentId || null,
    structureId: data?.structureId || null,
    inspId: data?.inspId || null,

    incidentId: null,
    primaryAssetType: data?.structureId ? 'Structure' : null,
    relatedAssetType: data?.structureId ? 'Structure' : null,
    primaryAssetId: data?.structureId || null,
    relatedAssetId: data?.structureId || null,
    startLatitude: data.startLatitude ? `${data.startLatitude}` : null,
    startLongitude: data?.startLongitude ? `${data.startLongitude}` : null,
    completionLatitude: data?.completionLatitude ? `${data.completionLatitude}` : null,
    completionLongitude: data?.completionLongitude ? `${data.completionLongitude}` : null,
    sites: uniqueSiteIdsForPipeline,

    completed: data?.completed ? data?.completed : moment().format('YYYY-MM-DDTHH:mm:ss')
  };
};

export const transformFormWrapperDataToWorkOrderDataTodo = async (
  data,
  id,
  inspection,
  updateApp = false
) => {
  const photoData = inspection
    ? data?.photo
    : await transformPhotoData(data?.photo, 'WorkOrder', updateApp);
  const documentList = inspection
    ? data?.document
    : await transformDocumentData(data?.document, 'WorkOrder', updateApp);
  let newRecordId = inspection
    ? inspection
    : (!inspection && localStorage.getItem('newRecordId')) || uuidv4();
  const uniqueId = id ? id : newRecordId;

  const { pipeline, structure, cache } = store.getState();
  const { pipelineMobileMap = {}, pipelineMobile = [] } = pipeline;
  const { structureMobile = [], structureMobileMap = {} } = structure;
  const { equipmentsMap = {}, equipments: cacheEquipments = [] } = cache;

  let appliesToType = '';
  let uniqueSiteIdsForPipeline = [];
  let structureSiteId = '';
  let equipmentSiteId = '';
  if (!id || !data?.appliesToType) {
    appliesToType = data?.siteId
      ? 'site'
      : data?.equipmentId
      ? 'equipment'
      : data?.structureId
      ? 'structure'
      : data?.pipelineId
      ? 'pipeline'
      : '';
  } else {
    appliesToType = data?.appliesToType;
  }

  if (appliesToType === 'pipeline') {
    const pipeLineData = id ? {} : pipelineMobile[pipelineMobileMap[data?.pipelineId]] || {};

    const siteIds = pipeLineData
      ? new Set([
          ...(pipeLineData?.fromSite ? [pipeLineData.fromSite] : []),
          ...(pipeLineData?.toSite ? [pipeLineData.toSite] : []),
          ...(pipeLineData?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeLineData?.wells?.map((x) => x.toLowerCase()) ?? [])
        ])
      : [];

    // get unique site ids, if work request created from pipeline
    uniqueSiteIdsForPipeline = data?.sites || Array.from(siteIds);
  } else if (appliesToType === 'structure') {
    const structureData = id ? {} : structureMobile[structureMobileMap[data?.structureId]] || {};
    structureSiteId = data?.siteId || structureData?.siteId;
  } else if (appliesToType === 'equipment') {
    const equipmentData =
      id && data?.appliesToType && data?.siteId
        ? {}
        : cacheEquipments[equipmentsMap[data?.equipmentId]] || {};
    equipmentSiteId = data?.siteId || equipmentData?.siteId;
  }

  return {
    //general
    appliesToType,
    newWorkOrder: true,
    detailInspections: data?.detailInspections || [],
    recordNumber: data?.recordNumber || null,
    recordTitle: data?.recordTitle || null,
    title: data?.title || null,
    priorityId: data?.priority || null,
    status: data?.status,
    // type: data?.type || null,
    typeId: data?.type || null,
    trade: data?.trade || null,
    due: data?.requestDueDate,
    description: data?.description || null,
    //Assignment

    responsible: data?.responsibleUsers
      ? [
          {
            woUserRequestId: data?.responsibleUsers || null
          }
        ]
      : null,
    administrators: data?.administrator
      ? [
          {
            woUserRequestId: data?.administrator || null
          }
        ]
      : null,
    //Your attachments
    photos: photoData || [],
    documents: documentList || [],
    siteId: data?.siteId || structureSiteId || equipmentSiteId || null,
    woId: uniqueId,
    workorderId: uniqueId,
    type: 'New Work Order',
    result: 'completed',
    entity: 'WorkOrder',
    isDone: false,
    counterReadings: null,
    labours: null,
    partEstimates: null,
    failureModes: null,
    outcomeId: null,
    // completed: null,
    originId: null,
    pipelineId: data?.pipelineId || null,
    equipmentId: data?.equipmentId || null, //Id of the equipment the Work Request is for
    structureId: data?.structureId || null,
    inspId: data?.inspId || null,
    incidentId: null,
    primaryAssetType: data?.structureId ? 'Structure' : null,
    relatedAssetType: data?.structureId ? 'Structure' : null,
    primaryAssetId: data?.structureId || null,
    relatedAssetId: data?.structureId || null,
    startLatitude: data?.startLatitude ? `${data?.startLatitude}` : null,
    startLongitude: data?.startLongitude ? `${data?.startLongitude}` : null,
    completionLatitude: data?.completionLatitude ? `${data?.completionLatitude}` : null,
    completionLongitude: data?.completionLongitude ? `${data?.completionLongitude}` : null,
    sites: uniqueSiteIdsForPipeline,
    // completed: data?.completed ? data?.completed : moment().format('YYYY-MM-DDTHH:mm:ss')
    completed: null
  };
};

export const transformFormWrapperDataToWorkOrderDataDone = async (
  data,
  id,
  inspection = false,
  updateApp = false
) => {
  const { pipeline, structure, cache } = store.getState();

  const photoData = inspection
    ? data?.photo
    : await transformPhotoData(data?.photo, 'WorkOrder', updateApp);
  const documentList = inspection
    ? data?.document
    : await transformDocumentData(data?.document, 'WorkOrder', updateApp);
  const parts = transformPartData(data?.parts);
  const counterReadings = transformCounterReadingData(data);
  let newRecordId = inspection
    ? inspection
    : (!inspection && localStorage.getItem('newRecordId')) || uuidv4();

  const uniqueId = !_.isEmpty(id) ? id : newRecordId;

  const { pipelineMobileMap = {}, pipelineMobile = [] } = pipeline;
  const { structureMobile = [], structureMobileMap = {} } = structure;
  const { equipmentsMap = {}, equipments: cacheEquipments = [] } = cache;

  let appliesToType = '';
  let uniqueSiteIdsForPipeline = [];
  let structureSiteId = '';
  let equipmentSiteId = '';
  if (!id || !data?.appliesToType) {
    appliesToType = data?.siteId
      ? 'site'
      : data?.equipmentId
      ? 'equipment'
      : data?.structureId
      ? 'structure'
      : data?.pipelineId
      ? 'pipeline'
      : '';
  } else {
    appliesToType = data?.appliesToType;
  }

  if (appliesToType === 'pipeline') {
    const pipeLineData = id ? {} : pipelineMobile[pipelineMobileMap[data?.pipelineId]] || {};

    const siteIds = pipeLineData
      ? new Set([
          ...(pipeLineData?.fromSite ? [pipeLineData.fromSite] : []),
          ...(pipeLineData?.toSite ? [pipeLineData.toSite] : []),
          ...(pipeLineData?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeLineData?.wells?.map((x) => x.toLowerCase()) ?? [])
        ])
      : [];

    // get unique site ids, if work request created from pipeline
    uniqueSiteIdsForPipeline = data?.sites || Array.from(siteIds);
  } else if (appliesToType === 'structure') {
    const structureData = id ? {} : structureMobile[structureMobileMap[data?.structureId]] || {};
    structureSiteId = data?.siteId || structureData?.siteId;
  } else if (appliesToType === 'equipment') {
    const equipmentData =
      id && data?.appliesToType && data?.siteId
        ? {}
        : cacheEquipments[equipmentsMap[data?.equipmentId]] || {};
    equipmentSiteId = data?.siteId || equipmentData?.siteId;
  }

  const workCompleted = data?.workCompletedDate
    ? moment(data?.workCompletedDate).format('YYYY-MM-DD')
    : null;

  const currentTime = moment();

  const workCompletedWithHours = workCompleted
    ? moment(workCompleted)
        .set({
          hour: currentTime.hour(),
          minute: currentTime.minute(),
          second: currentTime.second()
        })
        .format('YYYY-MM-DDTHH:mm:ss')
    : moment().format('YYYY-MM-DDTHH:mm:ss');

  return {
    //general
    appliesToType,
    detailInspections: data?.detailInspections || [],
    recordNumber: data?.recordNumber || null,
    recordTitle: data?.recordTitle || null,
    newWorkOrder: true,
    type: 'New Work Order',
    status: data?.status,

    title: data?.title || null,
    priorityId: data?.priority || null,
    // type: data?.type || null,
    typeId: data?.type || null,
    trade: data?.trade || null,
    due: data?.requestDueDate,
    description: data?.description || null,
    //Assignment
    responsible: data?.responsibleUsers
      ? [
          {
            woUserRequestId: data?.responsibleUsers || null
          }
        ]
      : null,
    administrators: data?.administrator
      ? [
          {
            woUserRequestId: data?.administrator || null
          }
        ]
      : null,
    //Your attachments
    photos: photoData || [],
    documents: documentList || [],
    siteId: data?.siteId || structureSiteId || equipmentSiteId || null,

    result: 'completed',
    entity: 'WorkOrder',
    isDone: true,
    woId: uniqueId,
    workorderId: uniqueId,
    labours: null,
    partEstimates: null,
    failureModes: null,

    outcomeId: null,
    // completed: null,
    originId: null,
    pipelineId: data?.pipelineId || null,
    equipmentId: data?.equipmentId || null,
    structureId: data?.structureId || null,
    inspId: data?.inspId || null,
    // incidentId: null,

    // worklog part
    notes: data?.technicalNotes || null,
    workStarted: data?.workStarted || null,
    workCompleted,
    counterReadings,
    regularHours: data?.regularHours || null,
    overTimeHours: data?.overTimeHours || null,
    actualLabour: data?.actualLabour || null,
    actualParts: data?.actualParts || null,
    parts,
    primaryAssetType: data?.structureId ? 'Structure' : null,
    relatedAssetType: data?.structureId ? 'Structure' : null,
    primaryAssetId: data?.structureId || null,
    relatedAssetId: data?.structureId || null,
    startLatitude: data?.startLatitude ? `${data?.startLatitude}` : null,
    startLongitude: data?.startLongitude ? `${data?.startLongitude}` : null,
    completionLatitude: data?.completionLatitude ? `${data?.completionLatitude}` : null,
    completionLongitude: data?.completionLongitude ? `${data?.completionLongitude}` : null,
    sites: uniqueSiteIdsForPipeline,

    completed: workCompletedWithHours
  };
};

export const transformFormWrapperDataToWorkOrderWorkLog = async (data, updateApp = false) => {
  const photoData = await transformPhotoData(data?.photo, 'WorkOrder', updateApp);
  const documentList = await transformDocumentData(data?.document, 'WorkOrder', updateApp);
  const parts = transformPartData(data?.parts);
  const counterReadings = transformCounterReadingData(data);

  // const workCompleted = data?.workCompleted
  //   ? moment(data?.workCompleted).format('YYYY-MM-DD')
  //   : data?.workCompletedDate
  //   ? moment(data?.workCompletedDate).format('YYYY-MM-DD')
  //     : null;

  const workCompleted = data?.workCompletedDate
    ? moment(data?.workCompletedDate).format('YYYY-MM-DD')
    : null;

  const currentTime = moment();

  const workCompletedWithHours = workCompleted
    ? moment(workCompleted)
        .set({
          hour: currentTime.hour(),
          minute: currentTime.minute(),
          second: currentTime.second()
        })
        .format('YYYY-MM-DDTHH:mm:ss')
    : moment().format('YYYY-MM-DDTHH:mm:ss');

  return {
    photos: photoData || [],
    documents: documentList || [],
    // worklog part
    notes: data?.technicalNotes || null,
    workStarted: data?.workStarted ? moment(data?.workStarted).format('YYYY-MM-DD') : null,
    workCompleted,
    counterReadings,
    regularHours: data?.regularHours || null,
    overTimeHours: data?.overTimeHours || null,
    actualLabour: data?.actualLabour || null,
    actualParts: data?.actualParts || null,
    parts,
    formData: data?.formData || null,
    completed: workCompletedWithHours
  };
};

export const transformPhotoData = async (
  photoData = [],
  documentType = 'WorkRequest',
  updateApp = false
) => {
  const transformedData = [];

  if (_.size(photoData) > 0) {
    for (const doc of photoData) {
      const file = updateApp ? { id: doc?.id, name: doc.fileName, type: doc?.mimeType } : '';
      const transformedDoc = {
        caption: doc?.caption || null,
        fileName: doc?.image?.name || null,
        photoCategory: doc?.category || null,
        content: updateApp ? file : doc.image,
        documentType,
        mimeType: doc?.image?.type || 'image/png',
        id: doc?.id || null
      };

      transformedData.push(transformedDoc);
    }
  }

  return transformedData;
};
export const transformDocumentData = async (
  documentData = [],
  documentType = 'WorkRequest',
  updateApp = false
) => {
  const transformedData = [];

  if (_.size(documentData) > 0) {
    for (const doc of documentData) {
      const file = updateApp
        ? {
            name: doc?.fileName,
            type: doc?.mimeType,
            id: doc?.id
          }
        : '';
      const transformedDoc = {
        fileName: doc?.file?.file?.name || null,
        documentCategory: doc?.category || null,
        content: updateApp ? file : doc?.file?.file,
        documentType,
        mimeType: doc?.file?.file?.type || 'application/pdf',
        id: doc?.id || null
      };

      transformedData.push(transformedDoc);
    }
  }

  return transformedData;
};
const transformPartData = (partsData = []) => {
  const parts =
    _.size(partsData) > 0
      ? partsData?.map((x) => {
          return {
            Id: x.id || null,
            PartNum: x?.part || null,
            PartName: x['part/materialName'] || null,
            Manufacturer: x?.manufactuer || null,
            Quantity: x?.quantity || null,
            Unit: x?.unit || null
          };
        })
      : null;
  return parts;
};
const transformCounterReadingData = (data) => {
  return data?.readingUnit || data?.reading
    ? [
        {
          id: uuidv4(),
          //   EquipmentId: data?.equipmentId || null,
          ...(data?.equipmentId && { EquipmentId: data?.equipmentId }),
          ReadingUnit: data?.readingUnit,
          Reading: data?.reading || null,
          ReadingDate: moment().format('YYYY-MM-DD'),
          ReadingTime: moment().format('HH:mm:ss')
        }
      ]
    : null;
};

export const prepareWorkOrderForBackend = ({
  newWorkRequestOrderOrder,
  inspectionFormsUserCache,
  equipmentsMap,
  cacheEquipments
}) => {
  let equipmentNewId = '';
  if (
    newWorkRequestOrderOrder?.equipmentId &&
    equipmentsMap[newWorkRequestOrderOrder.equipmentId] >= 0 &&
    cacheEquipments[equipmentsMap[newWorkRequestOrderOrder.equipmentId]]?.isNew
  ) {
    equipmentNewId = newWorkRequestOrderOrder.equipmentId;
  } else if (
    newWorkRequestOrderOrder?.equipmentId &&
    (equipmentsMap[newWorkRequestOrderOrder.equipmentId] < 0 ||
      !equipmentsMap[newWorkRequestOrderOrder.equipmentId])
  ) {
    equipmentNewId = newWorkRequestOrderOrder.equipmentId;
  }

  const {
    title,
    woId,
    priorityId,
    type,
    trade,
    due,
    description,
    result,
    entity,
    preparation,
    permitsReq,
    ToolsReq,
    safetyConcerns,
    enviroConcerns,
    isShutdownRequired,
    estimatedDowntime,
    originId,
    pipelineId,
    equipmentId,
    structureId,
    responsible,
    administrators,
    counterReadings,
    labours,
    partEstimates,
    failureModes,
    parts,
    outcomeId,
    // completed,
    inspId,
    incidentId,
    isDone,
    regularHours,
    overTimeHours,
    actualLabour,
    actualParts,
    notes,
    siteId,
    workStarted,
    detailInspections,
    recordNumber,
    recordTitle,
    workCompleted,
    startLatitude,
    startLongitude,
    completionLatitude,
    completionLongitude
  } = newWorkRequestOrderOrder;

  const workOrderLocation = {
    startLatitude: startLatitude ? `${startLatitude}` : null,
    startLongitude: startLongitude ? `${startLongitude}` : null,
    completionLatitude: completionLatitude ? `${completionLatitude}` : null,
    completionLongitude: completionLongitude ? `${completionLongitude}` : null
  };

  if (newWorkRequestOrderOrder.entity === 'WorkRequest') {
    // Work Request
    return {
      detailInspections,
      recordNumber,
      recordTitle,
      title,
      woId,
      priorityId,
      type,
      trade,
      due,
      description,
      responsible,
      administrators,
      result,
      entity,
      preparation,
      permitsReq,
      ToolsReq,
      safetyConcerns,
      enviroConcerns,
      isShutdownRequired,
      estimatedDowntime,
      originId,
      pipelineId,
      equipmentId,
      ...(equipmentNewId && { onDemandId: equipmentNewId }),
      // ...(!equipmentNewId && equipmentId && { equipmentId: equipmentId }),
      structureId,
      siteId,
      inspId,
      overTimeHours,
      actualStartDate: workStarted,
      primaryAssetId: structureId ? 'Structure' : '',
      primaryAssetType: structureId ? 'Structure' : '',
      relatedAssetId: structureId ? structureId : '',
      relatedAssetType: structureId ? 'Structure' : '',
      appliesToType: structureId ? 'structure' : '',
      structures: structureId ? [structureId] : [],
      completed: newWorkRequestOrderOrder?.completed || moment().format('YYYY-MM-DDTHH:mm:ss'),
      ...workOrderLocation
    };
  } else {
    // Work orders
    if (newWorkRequestOrderOrder.woId) {
      if (newWorkRequestOrderOrder.isDone) {
        // Done
        return {
          detailInspections,
          recordNumber,
          recordTitle,
          title,
          woId,
          priorityId,
          type,
          trade,
          due,
          description,
          result,
          entity,
          preparation,
          permitsReq,
          ToolsReq,
          safetyConcerns,
          enviroConcerns,
          isShutdownRequired,
          estimatedDowntime,
          originId,
          pipelineId,
          equipmentId,
          ...(equipmentNewId && { onDemandId: equipmentNewId }),
          // ...(!equipmentNewId && equipmentId && { equipmentId: equipmentId }),
          structureId,
          responsible,
          administrators,
          counterReadings,
          labours,
          partEstimates,
          failureModes,
          parts,
          outcomeId,
          // completed,
          inspId,
          incidentId,
          isDone,
          regHours: regularHours,
          otHours: overTimeHours,
          actualLabour,
          actualParts,
          notes,
          siteId,
          actualStartDate: workStarted,
          workCompleted: workCompleted,
          primaryAssetId: structureId ? 'Structure' : '',
          primaryAssetType: structureId ? 'Structure' : '',
          relatedAssetId: structureId ? structureId : '',
          relatedAssetType: structureId ? 'Structure' : '',
          appliesToType: structureId ? 'structure' : '',
          structures: structureId ? [structureId] : [],
          completed: newWorkRequestOrderOrder?.completed
            ? moment(newWorkRequestOrderOrder?.completed).format('YYYY-MM-DDTHH:mm:ss')
            : moment().format('YYYY-MM-DDTHH:mm:ss'),
          ...workOrderLocation
        };
      } else {
        // To do
        return {
          detailInspections,
          recordNumber,
          recordTitle,
          title,
          woId,
          priorityId,
          type,
          trade,
          due,
          description,
          result,
          entity,
          preparation,
          permitsReq,
          ToolsReq,
          safetyConcerns,
          enviroConcerns,
          isShutdownRequired,
          estimatedDowntime,
          originId,
          pipelineId,
          equipmentId,
          ...(equipmentNewId && { onDemandId: equipmentNewId }),
          // ...(!equipmentNewId && equipmentId && { equipmentId: equipmentId }),
          structureId,
          responsible,
          administrators,
          counterReadings,
          labours,
          partEstimates,
          failureModes,
          parts,
          outcomeId,
          // completed,
          inspId,
          incidentId,
          isDone,
          regularHours,
          overTimeHours,
          actualLabour,
          actualParts,
          notes,
          siteId,
          actualStartDate: workStarted,
          workCompleted: workCompleted,
          primaryAssetId: structureId ? 'Structure' : '',
          primaryAssetType: structureId ? 'Structure' : '',
          relatedAssetId: structureId ? structureId : '',
          relatedAssetType: structureId ? 'Structure' : '',
          appliesToType: structureId ? 'structure' : '',
          structures: structureId ? [structureId] : [],
          // completed: newWorkRequestOrderOrder?.completed
          //   ? moment(newWorkRequestOrderOrder?.completed).format('YYYY-MM-DDTHH:mm:ss')
          //   : moment().format('YYYY-MM-DDTHH:mm:ss'),
          completed: null,
          ...workOrderLocation
        };
      }
    } else {
      // Assigned WO
      const formData = newWorkRequestOrderOrder?.formData || {};

      const currentFrom =
        inspectionFormsUserCache?.find(
          (x) => x?.inspectionFormId === newWorkRequestOrderOrder?.formId
        ) || {};

      const { json } = transformJSON({ currentFrom, formData });

      const administratorsUsers = [
        ...([
          ...(newWorkRequestOrderOrder?.administrators || []),
          ...(newWorkRequestOrderOrder?.administratorUserGroups || [])
        ]?.map((a) => ({ woUserRequestId: a })) || {})
      ];

      const responsibleUsers = [
        ...([
          ...(newWorkRequestOrderOrder?.responsibleUsers || []),
          ...(newWorkRequestOrderOrder?.responsibleUserGroups || [])
        ]?.map((a) => ({ woUserRequestId: a })) || {})
      ];

      return {
        title,
        responsible: responsibleUsers,
        administrators: administratorsUsers,
        ...(!['Critical', 'Medium', 'High', 'Low'].includes(priorityId) && { priorityId }),
        type,
        trade,
        due,
        description,
        result,
        entity: 'WorkOrder',
        counterReadings,
        labours,
        partEstimates,
        failureModes,
        parts,
        outcomeId,
        // completed,
        preparation,
        permitsReq,
        ToolsReq,
        safetyConcerns,
        enviroConcerns,
        isShutdownRequired,
        estimatedDowntime,
        originId,
        pipelineId,
        equipmentId,
        ...(equipmentNewId && { onDemandId: equipmentNewId }),
        // ...(!equipmentNewId && equipmentId && { equipmentId: equipmentId }),
        structureId,
        inspId,
        incidentId,
        isDone,
        regHours: regularHours,
        otHours: overTimeHours,
        actualLabour,
        actualParts,
        notes,
        siteId,
        actualStartDate: workStarted,
        completed: newWorkRequestOrderOrder?.completed || moment().format('YYYY-MM-DDTHH:mm:ss'),
        workCompleted: workCompleted,
        primaryAssetId: structureId ? 'Structure' : pipelineId ? 'Pipeline' : '',
        primaryAssetType: structureId ? 'Structure' : pipelineId ? 'Pipeline' : '',
        relatedAssetId: structureId ? structureId : pipelineId ? pipelineId : '',
        relatedAssetType: structureId ? 'Structure' : pipelineId ? pipelineId : '',
        appliesToType: structureId ? 'Structure' : pipelineId ? 'Pipeline' : '',
        structures: newWorkRequestOrderOrder?.structures.length
          ? newWorkRequestOrderOrder?.structures
          : [],
        pipelines: newWorkRequestOrderOrder?.pipelines.length
          ? newWorkRequestOrderOrder?.pipelines
          : [],
        formdata: json,
        formId: newWorkRequestOrderOrder?.formId,
        ...workOrderLocation
      };
    }
  }
};

export const convertWorkOrderDataToHookFormData = ({ task }) => {
  return {
    photo: task?.photos || [],
    document: task?.documents || [],
    technicalNotes: task?.notes || null,
    workStarted: task?.workStarted
      ? moment(new Date(task?.workStarted)).format('YYYY-MM-DD')
      : null,
    workCompletedDate: task?.workCompleted
      ? moment(new Date(task?.workCompleted)).format('YYYY-MM-DD')
      : null,
    regularHours: task?.regularHours || null,
    overTimeHours: task?.overTimeHours || null,
    parts:
      task?.parts?.map((x) => {
        return {
          id: x?.Id,
          part: x?.['PartNum'],
          'part/materialName': x?.PartName,
          manufactuer: x?.Manufacturer,
          quantity: x?.Quantity,
          unit: x?.Unit
        };
      }) || [],
    reading: _.size(task?.counterReadings) > 0 ? task?.counterReadings[0]?.Reading : null,
    readingUnit: task?.unit || null,
    unit: _.size(task?.counterReadings) > 0 ? task?.counterReadings[0]?.ReadingUnit : null
  };
};
